<template>
  <div>
    <div
      class="mrm-node"
      :class="{ 'mrm-node--selected': isSelected, 'mrm-node--mapped': isMapped && !isSelected }"
      :style="{ paddingLeft: (depth * 16 + 8) + 'px' }"
    >
      <span v-if="isExpandable" class="mrm-chev" @click="toggle">
        <fa-icon :icon="expanded ? 'chevron-down' : 'chevron-right'" />
      </span>
      <span v-else class="mrm-chev mrm-chev--empty"></span>
      <span class="mrm-key">{{ fieldKey }}</span>
      <span class="mrm-t" :class="typeClass">{{ typeLabel }}</span>
      <span v-if="displayValue && !isExpandable" class="mrm-val">"{{ displayValue }}"</span>
      <CButton
        v-if="!isExpandable"
        size="sm"
        :color="isMapped ? 'success' : 'primary'"
        variant="outline"
        class="mrm-pick ml-auto"
        @click.stop="select"
        :title="isMapped ? 'Já vinculado' : 'Selecionar campo'"
      >
        <fa-icon :icon="isMapped ? 'check' : 'plus'" />
      </CButton>
    </div>
    <template v-if="expanded && children">
      <mrm-node
        v-for="(cv, ck) in children"
        :key="String(ck)"
        :fieldKey="String(ck)"
        :value="cv"
        :path="childPath + '.' + String(ck)"
        :depth="depth + 1"
        :selectedPath="selectedPath"
        :mappedPaths="mappedPaths"
        @select="$emit('select', $event)"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: "MrmNode",
  props: {
    fieldKey: { type: String, required: true },
    value: { default: null },
    path: { type: String, required: true },
    depth: { type: Number, default: 0 },
    selectedPath: { type: String, default: "" },
    mappedPaths: { type: Object, default: () => ({}) },
  },
  data() {
    return { expanded: this.depth < 1 };
  },
  computed: {
    isObject() { return this.value !== null && typeof this.value === "object" && !Array.isArray(this.value); },
    isArray() { return Array.isArray(this.value); },
    isExpandable() { return this.isObject || this.isArray; },
    typeLabel() {
      if (this.value === null || this.value === undefined) return "NULL";
      if (this.isArray) return "ARRAY(" + this.value.length + ")";
      if (this.isObject) return "OBJ";
      if (typeof this.value === "number") return "NUM";
      if (typeof this.value === "boolean") return "BOOL";
      return "STR";
    },
    typeClass() {
      if (this.isArray) return "mrm-t--arr";
      if (this.isObject) return "mrm-t--obj";
      if (typeof this.value === "number") return "mrm-t--num";
      if (this.value === null) return "mrm-t--null";
      if (typeof this.value === "boolean") return "mrm-t--bool";
      return "mrm-t--str";
    },
    displayValue() {
      if (this.isExpandable) return "";
      if (this.value === null) return "null";
      const s = String(this.value);
      return s.length > 35 ? s.substring(0, 35) + "..." : s;
    },
    children() {
      if (this.isArray && this.value.length > 0 && typeof this.value[0] === "object") return this.value[0];
      if (this.isObject) return this.value;
      return null;
    },
    childPath() { return this.isArray ? this.path + ".0" : this.path; },
    isSelected() { return this.path === this.selectedPath; },
    isMapped() { return !!(this.mappedPaths && this.mappedPaths[this.path]); },
  },
  methods: {
    toggle() { if (this.isExpandable) this.expanded = !this.expanded; },
    select() { this.$emit("select", this.path); },
  },
};
</script>

<style scoped>
.mrm-node {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  font-size: 12.5px;
  font-family: 'SF Mono', Consolas, monospace;
  transition: background 0.1s;
  cursor: default;
  border-bottom: 1px solid #f8f9fa;
}
.mrm-node:hover { background: #f8f9fa; }
.mrm-node--selected { background: #cce5ff !important; }
.mrm-node--mapped { background: #fff3cd; }
.mrm-chev { width: 12px; text-align: center; font-size: 9px; color: #6c757d; flex-shrink: 0; cursor: pointer; }
.mrm-chev--empty { visibility: hidden; }
.mrm-key { font-weight: 600; color: #343a40; white-space: nowrap; }
.mrm-t { font-size: 9px; font-weight: 700; padding: 1px 4px; border-radius: 2px; flex-shrink: 0; letter-spacing: 0.3px; }
.mrm-t--str { background: #d4edda; color: #155724; }
.mrm-t--num { background: #cce5ff; color: #004085; }
.mrm-t--null { background: #e2e3e5; color: #6c757d; }
.mrm-t--obj, .mrm-t--arr { background: #e2d9f3; color: #4a1e8c; }
.mrm-t--bool { background: #fff3cd; color: #856404; }
.mrm-val { color: #6c757d; font-size: 11.5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; }
.mrm-pick { padding: 1px 7px !important; font-size: 11px !important; }
</style>
